















import { Component, Vue } from "vue-property-decorator";
import ONP from "./ONP.vue";
import Intro from "./Intro.vue";
import Logo from "./Logo.vue";
import firebase from "firebase";
import Cutscene from "./Cutscene.vue";
import Cutscene2 from "./Cutscene2.vue";
import GameRank from "./GameRank.vue";
import SoundManagerONP from "../SoundManagerONP";
import { MetaInfo } from "vue-meta";
@Component<Container>({
  metaInfo(): MetaInfo {
    return {
      title: "OldManAndThePlastics",
      meta: [
        { charset: "utf-8" },
        { name: "og:title", content: "OldManAndThePlastics | Greenplay" },
        { name: "og:url", content: "https://greenplay.online/onp" },
        {
          name: "og:image",
          content: "https://greenplay.online/apple-touch-icon.png",
        },
        {
          name: "og:description",
          content: "Hold your fart to save the Earth!",
        },
      ],
    };
  },
  components: {
    ONP,
    Intro,
    Logo,
    Cutscene,
    Cutscene2,
    GameRank,
  },
})
export default class Container extends Vue {
  public currentComponent: any;

  public OnNext(content: any): void {
    window.scrollTo(0, 0);
    if (content instanceof Intro) {
      firebase.analytics().setCurrentScreen("Logo");
      SoundManagerONP.logoSound();
      this.currentComponent = Logo;
    } else if (content instanceof Logo) {
      firebase.analytics().setCurrentScreen("Cutscene");
      this.currentComponent = Cutscene;
    } else if (content instanceof Cutscene) {
      firebase.analytics().setCurrentScreen("Cutscene2");
      this.currentComponent = Cutscene2;
    } else if (content instanceof Cutscene2) {
      firebase.analytics().setCurrentScreen("NOBC");
      this.currentComponent = ONP;
    }

    firebase.analytics().logEvent("screen_view");
  }
  public OnName(name: string) {
    this.userName = name;
  }
  private userName: string = "unknown";
  private userCC: number = 0;
  private userImg: string = "";
  public OnRank(rank: any) {
    rank.SetInfo(this.userName, this.userCC, this.userImg);
  }

  public OnGameEnd(endPopup: any): void {
    endPopup.gameData.name = this.userName;
  }

  public OnScore(endPopup: any): void {
    this.userCC = endPopup.gameData.ccNum;
    var name = this.userName;
    var id = firebase.auth().currentUser?.uid;

    var canvas = endPopup.targetImageData;
    var storageRef = firebase.storage().ref();
    var o = this;
    canvas.toBlob(
      function (blob: any) {
        var image = new Image();
        image.src = blob;
        var uploadTask = storageRef
          .child(
            "onpImages/" +
              encodeURIComponent(name) +
              ":" +
              encodeURIComponent(endPopup.gameData.date) +
              ":" +
              endPopup.gameData.ccNum +
              ".jpg"
          )
          .put(blob);

        // Listen for state changes, errors, and completion of the upload.
        uploadTask.on(
          firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
          (snapshot) => {
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            var progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + progress + "% done");
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                console.log("Upload is paused");
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                console.log("Upload is running");
                break;
            }
          },
          (error) => {
            // A full list of error codes is available at
            // https://firebase.google.com/docs/storage/web/handle-errors
            switch (error.code) {
              case "storage/unauthorized":
                // User doesn't have permission to access the object
                break;
              case "storage/canceled":
                // User canceled the upload
                break;

              // ...

              case "storage/unknown":
                // Unknown error occurred, inspect error.serverResponse
                break;
            }
          },
          () => {
            // Upload completed successfully, now we can get the download URL
            uploadTask.snapshot.ref
              .getDownloadURL()
              .then((downloadURL): void => {
                console.log("File available at", downloadURL);
                o.userImg = downloadURL;
                //endPopup.setShareBtn(downloadURL);
                var db = firebase.firestore();
                // Get a new write batch
                var batch = db.batch();

                // Set the value of 'NYC'
                var addRef = db.collection("onp").doc();
                batch.set(addRef, {
                  name: name,
                  score: endPopup.gameData.ccNum,
                  date: firebase.firestore.FieldValue.serverTimestamp(),
                  uid: id,
                  url: downloadURL,
                });

                // Update the population of 'SF'
                var commonRef = db.collection("onp").doc("common");

                batch.update(commonRef, {
                  count: firebase.firestore.FieldValue.increment(1),
                  total: firebase.firestore.FieldValue.increment(
                    endPopup.gameData.ccNum
                  ),
                });

                // Commit the batch
                batch.commit().then(() => {
                  // ...
                });
              });
          }
        );
      },
      "image/jpeg",
      0.6
    );
  }
  private IsTurned = false;
  private hasTouch() {
    return (
      "ontouchstart" in window || // html5 browsers
      navigator.maxTouchPoints > 0 || // future IE
      navigator.msMaxTouchPoints > 0
    ); // current IE10
  }
  mounted(): void {
    SoundManagerONP.loadCheck();
    this.IsTurned = false;
    if (!this.hasTouch()) {
      this.$router.replace("/warningMobileONP");
      return;
    }
    if (
      document.documentElement.clientHeight <
      document.documentElement.clientWidth
    ) {
      this.$router.replace("/warningONP");
      return;
    }
    window.addEventListener("orientationchange", () => {
      var afterOrientationChange = () => {
        if (this.IsTurned) return;
        if (
          document.documentElement.clientHeight <
          document.documentElement.clientWidth
        ) {
          this.IsTurned = true;
          this.$router.replace("/warningONP");
        }
        window.removeEventListener("resize", afterOrientationChange);
      };
      window.addEventListener("resize", afterOrientationChange);
    });

    document.body.style.overflowY = "hidden";
    firebase.analytics().setCurrentScreen("Intro");
    firebase.analytics().logEvent("screen_view");
    this.currentComponent = Intro;

    firebase
      .auth()
      .signInAnonymously()
      .then((): void => {
        // Signed in..
        console.log("logged in+" + firebase.auth().currentUser?.uid);
        var db = firebase.firestore();

        /*db.collection("onp")
          .orderBy("score", "desc")
          .limit(100)
          .get()
          .then((querySnapshot): void => {
            querySnapshot.forEach((doc): void => {
              // doc.data() is never undefined for query doc snapshots
              //console.log(doc.id, " => ", doc.data());
            });
          })
          .catch((error): void => {
            console.log("Error getting documents: ", error);
          });*/
      })
      .catch((error): void => {
        var errorCode = error.code;
        var errorMessage = error.message;
        // ...
      });
  }
  data(): { currentComponent: any } {
    return {
      currentComponent: this.currentComponent,
    };
  }
}
